/* MV スライダー */
var mvSwiper = new Swiper('.mv__swiper', {
  loop: true,
  speed: 600,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.mv__pagination',
    clickable: true,
  },
  effect: 'fade'
});
// タブの切り替え
document.querySelectorAll('.lineup__tab').forEach(function (tab) {
  tab.addEventListener('click', function () {
    var target = tab.dataset.tab;

    document.querySelectorAll('.lineup__tab').forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.tab === target);
    });

    document.querySelectorAll('.lineup__panel').forEach(function (p) {
      p.classList.toggle('is-active', p.dataset.panel === target);
    });
  });
});
/* entry セクション アコーディオン */
document.querySelectorAll('.js-acc-trigger').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var body = btn.nextElementSibling; // .entry__body
    var isOpen = btn.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      // 閉じる
      body.style.maxHeight = body.scrollHeight + 'px'; // 一旦実数値に
      requestAnimationFrame(function () {
        body.style.maxHeight = '0px';
      });
      btn.setAttribute('aria-expanded', 'false');
    } else {
      // 開く
      body.style.maxHeight = body.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});
window.addEventListener('resize', function() {
  document.querySelectorAll('.js-acc-trigger').forEach(function (btn) {
    var body = btn.nextElementSibling; // .entry__body
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      body.style.maxHeight = body.scrollHeight + 'px';
    }
  });  
});

/* 開いた要素の中身（画像など）読み込みで高さが変わった時に追従 */
window.addEventListener('load', function () {
  document.querySelectorAll('.entry__heading[aria-expanded="true"]').forEach(function (btn) {
    var body = btn.nextElementSibling;
    body.style.maxHeight = body.scrollHeight + 'px';
  });
});

/* 規約モーダルの開閉 */
var teamModal = document.getElementById('teamModal');

document.querySelectorAll('.js-team-open').forEach(function (el) {
  el.addEventListener('click', function (e) {
    e.preventDefault();
    teamModal.classList.add('is-open');
  });
});

document.querySelectorAll('.js-team-close').forEach(function (el) {
  el.addEventListener('click', function () {
    teamModal.classList.remove('is-open');
  });
});

/* ご購入モーダルの開閉 */
var buyModal = document.getElementById('buyModal');

document.querySelectorAll('.js-buy-open').forEach(function (el) {
  el.addEventListener('click', function (e) {
    e.preventDefault();
    buyModal.classList.add('is-open');
  });
});

document.querySelectorAll('.js-buy-close').forEach(function (el) {
  el.addEventListener('click', function () {
    buyModal.classList.remove('is-open');
  });
});

/* モーダル内ショップのアコーディオン */
document.querySelectorAll('.js-shop-acc').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var body = btn.nextElementSibling; // .shop__body
    var isOpen = btn.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      body.style.maxHeight = '0px';
      btn.setAttribute('aria-expanded', 'false');
    } else {
      body.style.maxHeight = body.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});
/* FVボタンが見切れたら追従バーを表示 */
var fixedBar = document.getElementById('fixedBar');
var mvBtns = document.querySelector('.mv__btns');

if (fixedBar && mvBtns && 'IntersectionObserver' in window) {
  var barObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      // FVボタンが画面から消えたらバーを表示、見えていれば隠す
      if (entry.isIntersecting) {
        fixedBar.classList.remove('is-visible');
      } else {
        fixedBar.classList.add('is-visible');
      }
    });
  }, {
    threshold: 0,
  });

  barObserver.observe(mvBtns);
}